/**
 * Maintain compatibility for legacy bundles that still reference
 * `setDealSheetFocusedId` before React hydrates. We expose a proxy
 * that forwards to the real implementation registered inside the app.
 * Previously implemented in public/scripts/legacy-shim.js.
 */
function proxySetDealSheetFocusedId(id: string | null) {
  try {
    const actual = (window as any).__setDealSheetFocusedIdActual;
    if (typeof actual === "function") {
      actual(id);
    }
  } catch {
    /* no-op */
  }
}

try {
  (window as any).setDealSheetFocusedId = proxySetDealSheetFocusedId;
  try {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    (globalThis as any).setDealSheetFocusedId = proxySetDealSheetFocusedId;
  } catch {
    /* no-op */
  }
} catch {
  /* no-op */
}
